require('./bootstrap');

import { createApp, h } from 'vue'
import { App, Link, plugin } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import router from './router';

import '@fontsource/lato/100.css';
import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';

import 'v-calendar/style.css';
InertiaProgress.init()

const el = document.getElementById('app')

const app = createApp({
    render: () => h(App, {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => import(`./Pages/${name}`).then(module => module.default),
    })
});

app.use(plugin);

app.component('inertia-link', Link);

app.config.globalProperties.$route = router;

app.mount(el)
